import React from 'react';
import { useTranslation } from 'react-i18next';

const MenuCarousel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="section-padding">
        <div className="text-center mb-8 md:mb-12">
          <p className="text-koi-red text-lg tracking-luxury uppercase font-body mb-4">
            {t('menuCarousel.title')}
          </p>
          <h2 className="text-display-md md:text-display-lg font-display mb-6 text-gray-800">
            {t('menuCarousel.viewMenus')}
          </h2>
          <div className="h-px bg-koi-red mx-auto w-20" />
        </div>

        <div className="relative mx-auto max-w-5xl">
          <div className="relative bg-koi-light/30 rounded-lg overflow-hidden p-6">
            <img
              src="/menu-restaurant.png"
              alt="Menu Royal O'Nara"
              className="mx-auto shadow-lg rounded-lg"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '1000px',
                display: 'block',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuCarousel;